import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { matchTimeEntryError } from './time-entry-errors'

/**
 * Shows the toast for a known time-entry rejection.
 *
 * Returns `true` when it handled the message, so each call site keeps its own
 * fallback for anything unrecognised.
 */
export function useTimeEntryErrorToast() {
  const addToast = useToast()
  const translations = useTranslate({
    overlapping: 'timesheets.warning.time-entry-exist-in-daterange',
    commentRequired: 'timesheets.error.comment-required',
    endBeforeStart: 'timesheets.error.entry-end-before-start',
    tooLong: 'timesheets.error.entry-too-long',
  })

  return function showTimeEntryError(
    message: string | undefined | null
  ): boolean {
    const matched = matchTimeEntryError(message)
    if (!matched) return false

    addToast(matched.type, translations[matched.key])
    return true
  }
}
